import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { TASK_TYPES } from 'utils/Constants';

import Pill from 'components/Misc/Pill';
import { Button } from 'components/Misc/Form';
import { Title } from 'components/Misc/Typography';
import { Element, Handle } from 'components/Misc/Sortable';

import { useExamProfileStore } from 'store/exam/useExamProfileStore';

const Task = ({ idx, task }) => {
	// Cache exam's id
	const { id } = useParams();

	// Use exam's profile store
	const editable = useExamProfileStore(state => state.exam.editable);

	// Find type info
	const type = useMemo(() => TASK_TYPES.find(type => type.value === task.type), [task.type]);

	return (
		<Element index={idx} className="py-3 px-4 flex items-center space-x-2 border border-neutral-200 dark:border-neutral-700 rounded-lg transition-colors">
			<Handle />

			<Title
				title={`${task.order}. uzdevums`}
				subtitle={type.text}
				className="flex-1"
			/>

			<Pill name={`${task.sample} jautājumi`} />

			<Pill name={`${task.sample * task.points} punkti`} />

			<Button
				small
				square
				icon={editable ? 'edit' : 'link'}
				to={editable ? `/exams/tasks/edit/${id}/${task.id}` : `/exams/tasks/view/${id}/${task.id}`}
			/>
		</Element>
	);
};

export default Task;